import { Stack } from '@mui/material'
import LinearChart from 'components/cattles/lamenessPage/shared/LinearChart'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import moment from 'moment'
import { useAppSelector } from 'store/hooks'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../baseWidget'
import { LamenessWidgetTable } from './Table/LamenessWidgetTable'
import { useGetLamenessChartInfo } from './hooks/useGetLamenessChartInfo'

export const LamenessWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()
	const { dotsInfo, totalCattle, limpnessTotalCattles } =
		useGetLamenessChartInfo(statistics)

	if (!permissions?.license_limpness || error) return null

	const milky = statistics?.herd?.milky
	const dry = statistics?.herd?.dry
	const herdTotalCattle = milky == null || dry == null ? 0 : milky + dry
	const todayLabel = moment().format('DD.MM.YYYY')

	return (
		<BaseWidget
			isLoading={loading}
			path='/cattles/lameness'
			pathLable='Смотреть список'
		>
			<Stack direction='row' alignItems='center' gap='8px' mb='24px'>
				<TypographyPrimary16Bold>Хромота</TypographyPrimary16Bold>
				<TypographySecondary>{todayLabel}</TypographySecondary>
			</Stack>
			<Stack
				direction='row'
				justifyContent='space-between'
				alignItems='center'
				mb='24px'
			>
				<TypographyPrimary>Всего хромых голов</TypographyPrimary>
				<TypographyPrimary16Bold>
					{limpnessTotalCattles}
				</TypographyPrimary16Bold>
			</Stack>
			<Stack direction='column' gap='8px'>
				<LinearChart dotsInfo={dotsInfo} totalCount={totalCattle} />
				<LamenessWidgetTable
					limpness={statistics?.limpness ?? []}
					totalCattle={herdTotalCattle}
				/>
			</Stack>
		</BaseWidget>
	)
}
